import { useEffect, useState } from "react";
import useAuth from "../context/AuthProvider";
import { LinearProgress } from "@mui/material";
import React from "react";
import { apiClient } from "../helper/api";
import { LicenseMatrix } from "../components/Lists/LicenseMatrix";
import { licenseMatrixColumnList } from "../components/Lists/constants";
import { writeXlsxFile, formatUtcToLocal } from "../helper/utils";
import moment from "moment";

interface LicenseesContactInformation {
    partnerLincenseeInformationId: any;
    customerName: string;
    partnersId: any;
    postalAbbvs: string;
    licenseeName: string;
    pageSize: number;
    pageNumber: number;
    cancellationDate: any;
    stopStateReportsDate: any;
    entity: any;
    fein: any;
    licenseNumber: any;
    licenseState: any;
    licensee: any;
    mainLicensee: any;
    npn: any;
    title: any;
    status: string;
    statusReason: string;
    agencyLicenseNumber: any;
    slaBrokerNumber: any;
}

export const LicenseContactInformation = () => {
    const [licenseesContactArry, setLicenseesContactArry] = useState<LicenseesContactInformation[]>([]);
    const { user } = useAuth();
    const token = user?.token;
    const [pageSize, setPageSize] = React.useState<number>(50);
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });
    const [sortModel, setSortModel] = useState([{ field: "", sort: "" }]);
    const [loading, setLoading] = useState(false);
    const [selectedStateId, setSelectedStateId] = useState<number>(0);
    const [selectedLicenseeName, setSelectedLicenseeName] = useState<string>('');
    const [selectedPartner, setSelectedPartner] = React.useState<number>(0);
    const [selectedStatus, setSelectedStatus] = useState<string>('Active');
    const [selectedRows, setSelectedRows] = useState<LicenseesContactInformation[]>([]);

    const getLicenseMatrix = async (pageNumber: number, pageSize: number) => {
        setLoading(true)
       
        const bodyParams = {
            partnersId: selectedPartner,
            licenseStateId: selectedStateId,
            licensee: selectedLicenseeName,
            status: selectedStatus,
            licenseeIds: pageSize === totalCount ? selectedRows?.map(m => m.partnerLincenseeInformationId).join(',') || "" : "",
            pageNumber: pageNumber,
            pageSize: pageSize,
            field: sortModel?.[0]?.['field'] || '',
            sort: sortModel?.[0]?.['sort'] || '',
            filterModel: JSON.stringify(filterModel)
        };
        const res = await apiClient(`/LicenseMatrix/getLicenseMatrixData`, {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
            body: JSON.stringify(bodyParams)
        })
        setLoading(false)
        return res
    }

    const fetchLicenseMatrixData = async (pageNumber: number, pageSize: number) => {
        const res = await getLicenseMatrix(pageNumber, pageSize)
        if (!res?.data) {
            setLicenseesContactArry([]);
            setTotalCount(0);
            return
        }

        const licenseeData = res.data.getData_Resp as LicenseesContactInformation[];
        setLicenseesContactArry(licenseeData ?? []);
        setTotalCount(res.data.totalCount);
    };

    const handleExportXlsx = async (selectedItems: LicenseesContactInformation[]) => {
        let licenseeData: LicenseesContactInformation[] = selectedItems

        if (selectedItems.length == 0) {
            const res = await getLicenseMatrix(totalCount, 0)
            licenseeData = res?.data ? res.data.getData_Resp as LicenseesContactInformation[] : []
        }

        const headerRow = licenseMatrixColumnList.map((col: any) => col.xlsHeader)
        const exportItems: any[] = [headerRow]
        licenseeData.forEach((item) => {
            const row = licenseMatrixColumnList.map((col: any) => {
                const field = col.field as keyof LicenseesContactInformation
                const value = item[field]
                switch(col.inputType) {
                    case 'string':
                        return value?.toString() ?? ''
                    case 'date':
                        return value ? formatUtcToLocal(value as string, 'MM-DD-YYYY') : undefined;
                    default:
                        return value
                }
            })
            exportItems.push(row)
        })
        const excelExportName = 'LicenseMatrix'
        const timeStamp = moment().format('YYYY.M.D')
        return writeXlsxFile(exportItems, `${timeStamp}_${excelExportName}.xlsx`)
    }

    useEffect(() => {
        fetchLicenseMatrixData(pageNumber, pageSize);
    }, [pageSize, pageNumber, filterModel, sortModel, selectedStateId, selectedLicenseeName, selectedPartner, selectedStatus]);

    return (
        <>
            <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
                {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
            </div>
            <LicenseMatrix
                onExportXlsx={handleExportXlsx}
                licenseesContactArry={licenseesContactArry}
                totalCount={totalCount}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                setFilterModel={setFilterModel}
                setSortModel={setSortModel}
                sortModel={sortModel}
                selectedStateId={selectedStateId}
                setSelectedStateId={setSelectedStateId}
                selectedLicenseeName={selectedLicenseeName}
                setSelectedLicenseeName={setSelectedLicenseeName}
                selectedPartner={selectedPartner}
                setSelectedPartner={setSelectedPartner}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                getLicenseMatrix={getLicenseMatrix}
                fetchLicenseMatrixData={fetchLicenseMatrixData}
            />
        </>
    )
}